var map = {
	"./locale-da-DK": 92393,
	"./locale-da-DK.ts": 92393,
	"./locale-de-DE": 67536,
	"./locale-de-DE.ts": 67536,
	"./locale-en-GB": 42168,
	"./locale-en-GB.ts": 42168,
	"./locale-fo-FO": 9997,
	"./locale-fo-FO.ts": 9997,
	"./locale-is-IS": 60757,
	"./locale-is-IS.ts": 60757,
	"./locale-kl-GL": 8673,
	"./locale-kl-GL.ts": 8673,
	"./locale-nn-NO": 35999,
	"./locale-nn-NO.ts": 35999,
	"./locale-sv-SE": 50379,
	"./locale-sv-SE.ts": 50379
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 66691;
module.exports = webpackAsyncContext;